import * as React from "react";
import { Box, Link, SpaceBetween, TextContent } from "@amzn/awsui-components-react";
import { QueryResultItem } from "@aws-sdk/client-kendra";
import { StringUtils } from "../../../utils/common-utils";
import { getInstanceIdFromResult } from "../../../utils/search-utils";
import { SearchInstanceBadge } from "./SearchInstanceBadge";
import { PageSourceLink } from "./PageSourceLink";
import { AppContext } from "../../../setup/context";
import { useAPI } from "../../../hooks/api-hook";

export const LinkAnswers = (props: {
    results: QueryResultItem[],
    instanceId?: string
}) => {
    const context = React.useContext(AppContext);
    const protocolsRegex = new RegExp("^https?:\\/\\/");
    const mailtoRegex = new RegExp(/^mailto:/);

    const recordViewHistoryRunner = useAPI(
        context.getCommonAPI().recordViewHistory
    );

    return (
        <React.Fragment>
            <SpaceBetween direction="vertical" size="xs">
                <h5>Related Quick Links</h5>
                <div style={{
                    padding: "10px",
                    borderRadius: "25px",
                    border: "1px solid lightgray",
                    backgroundColor: "whitesmoke",
                    maxWidth: "350px"
                }}>
                    <TextContent>
                        <SpaceBetween direction="vertical" size="xxs">
                            {props.results.map(result => {
                                const linkText = result.AdditionalAttributes[0].Value.TextWithHighlightsValue.Text;
                                const linkUrl = StringUtils.extractTextFromHTML(
                                    result.AdditionalAttributes[1].Value.TextWithHighlightsValue.Text
                                );
                                const formattedUrl = (!!protocolsRegex.test(linkUrl) || !!mailtoRegex.test(linkUrl))
                                    ? linkUrl
                                    : "https://" + linkUrl;
                                const instanceId = getInstanceIdFromResult(result);
                                const handleClick = () => {
                                    if (props.instanceId) {
                                        recordViewHistoryRunner.submitRun({
                                            type: "Toolkit",
                                            entityId: props.instanceId,
                                            url: formattedUrl,
                                        });
                                    }
                                };
                                return (
                                    <Box key={result.Id} padding="xxxs" className="search-result-item">
                                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                            <span onClick={handleClick}>
                                                <Link external={true} href={formattedUrl}>
                                                    {linkText}
                                                </Link>
                                            </span>
                                            <PageSourceLink
                                                resultItem={result}
                                                instanceId={props.instanceId}
                                                variant="compact"
                                            />
                                            {instanceId && (
                                                <SearchInstanceBadge
                                                    instanceId={instanceId}
                                                />
                                            )}
                                        </SpaceBetween>
                                    </Box>
                                );
                            })}
                        </SpaceBetween>
                    </TextContent>
                </div>
            </SpaceBetween>
        </React.Fragment>
    );
};
